var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-oops-404-error-with-a-broken-robot:not(.animated) .animable {opacity: 0;}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #eli8vhyq9nhes {animation: 1.6s 1 forwards ease-in fadeIn;animation-delay: 0s;}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #elxw4g465wrs {animation: 1.6s 1 forwards ease-in fadeIn;animation-delay: 0.8s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #freepik--background-simple--inject-10 {animation: 1.6s 1 forwards ease-in fadeIn;animation-delay: 0s;}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #el95ihoxodits {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0s;}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #ela1wdpxxot4w {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.045454545454545456s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #elhvlf97s2cf6 {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.09090909090909091s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #eleb8n7pot8c7 {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.13636363636363635s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #elusf15li9q5 {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.18181818181818182s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #eldkoh3b7o2pw {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.2272727272727273s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #elhx6gtxf1t8e {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.2727272727272727s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #el179c92hq8x1 {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.3181818181818182s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #el8ef3iiwdaci {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.36363636363636365s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #el7corwox3wbm {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.4090909090909091s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #elrllxqv13xq9 {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.4545454545454546s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #elrtf38tba8eb {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.5s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #elq2rzs5zwdb {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.5454545454545454s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #eld2pjoal7ikh {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.5909090909090909s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #el3ruq6hweuoo {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.6363636363636364s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #elc79tb6dbipq {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.6818181818181819s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #el77nefqr5qnq {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.7272727272727273s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #el9coxs7us9lg {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.7727272727272727s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #elw4zvbx3p1p {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.8181818181818182s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #el0fdx7xbdlr85 {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.8636363636363636s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #el8ovawfgdpn6 {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.9090909090909092s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #el90kfq8oglp {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0.9545454545454546s;opacity: 0}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #freepik--Text--inject-10 {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0s;}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #freepik--Plants--inject-10 {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0s;}svg#freepik_stories-oops-404-error-with-a-broken-robot.animated #freepik--Character--inject-10 {animation: 1s 1 forwards ease-in fadeIn;animation-delay: 0s;}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "251.978px 255.305px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m51.08 268.53s2.33 72.16 62.57 120.25 143.69 51.54 211.26 56.11 119.47-33.69 127.29-91.51-43.81-74.79-71.82-140.61-25.52-87.46-84.79-127.94-152-15.62-200.59 53.73-43.92 129.97-43.92 129.97z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "251.978px 255.305px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m51.08 268.53s2.33 72.16 62.57 120.25 143.69 51.54 211.26 56.11 119.47-33.69 127.29-91.51-43.81-74.79-71.82-140.61-25.52-87.46-84.79-127.94-152-15.62-200.59 53.73-43.92 129.97-43.92 129.97z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      transformOrigin: "251.978px 255.305px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "240.785px 283.16px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 438.63,
    x2: 42.94,
    y1: 283.16,
    y2: 283.16,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "240.785px 283.16px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    fill: "#263238",
    style: {
      transformOrigin: "134.68px 235.165px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115.52,167.84c0-2.75,1.27-4.77,4.13-4.77s4.18,2,4.18,4.77v9.66c0,2.75-1.27,4.77-4.18,4.77s-4.13-2-4.13-4.77Zm1.24,9.74c0,2,.81,3.56,2.89,3.56s2.94-1.51,2.94-3.56v-9.82c0-2-.84-3.56-2.94-3.56s-2.89,1.51-2.89,3.56Z",
    style: {
      transformOrigin: "119.675px 172.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M125.8,167.84c0-2.75,1.27-4.77,4.12-4.77s4.18,2,4.18,4.77v9.66c0,2.75-1.26,4.77-4.18,4.77s-4.12-2-4.12-4.77Zm1.24,9.74c0,2,.81,3.56,2.88,3.56s2.94-1.51,2.94-3.56v-9.82c0-2-.83-3.56-2.94-3.56s-2.88,1.51-2.88,3.56Z",
    style: {
      transformOrigin: "129.95px 172.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M140.06,163.23c2.92,0,4.05,1.84,4.05,4.59v2.05c0,3-1.38,4.47-4.37,4.47h-2.35v7.77h-1.24V163.23Zm-.32,10c2.18,0,3.13-1,3.13-3.26v-2.21c0-2.05-.7-3.37-2.81-3.37h-2.67v8.84Z",
    style: {
      transformOrigin: "140.13px 172.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m153.93 167.79v0.4h-1.19v-0.48c0-2-0.75-3.51-2.8-3.51s-2.81 1.49-2.81 3.48c0 4.59 6.82 4.67 6.82 9.87 0 2.72-1.18 4.72-4.07 4.72s-4.07-2-4.07-4.72v-1h1.19v1c0 2 0.78 3.48 2.86 3.48s2.85-1.46 2.85-3.48c0-4.53-6.82-4.61-6.82-9.87 0-2.83 1.24-4.66 4-4.69s4.04 2.08 4.04 4.8z",
    style: {
      transformOrigin: "149.88px 172.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m157 179.74v2.37h-1.21v-2.37z",
    style: {
      transformOrigin: "156.395px 180.925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m160.4 179.74v2.37h-1.21v-2.37z",
    style: {
      transformOrigin: "159.795px 180.925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m163.77 179.74v2.37h-1.21v-2.37z",
    style: {
      transformOrigin: "163.165px 180.925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M71.26,246.67l21.25-50.25h12.75v50.25h5.52v10.62h-5.52v13.49H93.78V257.29H71.26Zm22.52,0V218.73L82,246.67Z",
    style: {
      transformOrigin: "91.02px 233.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m115.14 214.26c0-11.89 6.27-18.69 17.74-18.69s17.74 6.8 17.74 18.69v38.67c0 11.9-6.27 18.7-17.74 18.7s-17.74-6.8-17.74-18.7zm11.68 39.42c0 5.31 2.34 7.33 6.06 7.33s6.06-2 6.06-7.33v-40.16c0-5.31-2.34-7.33-6.06-7.33s-6.06 2-6.06 7.33z",
    style: {
      transformOrigin: "132.88px 233.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M155.4,246.67l21.25-50.25H189.4v50.25h5.52v10.62H189.4v13.49H177.92V257.29H155.4Zm22.52,0V218.73l-11.79,27.94Z",
    style: {
      transformOrigin: "175.16px 233.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M76.38,288.64c2.86,0,4,1.8,4,4.49v2c0,2.93-1.35,4.39-4.28,4.39h-2.3v7.6H72.55V288.64Zm-.31,9.78c2.14,0,3.06-1,3.06-3.2v-2.17c0-2-.68-3.3-2.75-3.3H73.77v8.67Z",
    style: {
      transformOrigin: "76.465px 297.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M83.6,303l-.93,4.09h-1.1l4-18.52h1.77l4.12,18.52H90.28L89.36,303Zm.18-1.06h5.39l-2.72-12Z",
    style: {
      transformOrigin: "86.515px 297.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m101.23 293.16v1.37h-1.17v-1.45c0-2-0.76-3.49-2.8-3.49s-2.8 1.51-2.8 3.49v9.62c0 2 0.77 3.46 2.8 3.46s2.8-1.48 2.8-3.46v-4h-2.45v-1.1h3.62v5c0 2.67-1.17 4.67-4 4.67s-4-2-4-4.67v-9.46c0-2.67 1.16-4.68 4-4.68s4 2.03 4 4.7z",
    style: {
      transformOrigin: "97.23px 297.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M109.52,297.2v1.11h-5V306h6.07v1.1h-7.29V288.64h7.29v1.11h-6.07v7.45Z",
    style: {
      transformOrigin: "106.945px 297.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m117.74 307.13h-1.11v-18.49h1.59l5.55 15.61v-15.61h1.11v18.49h-1.35l-5.79-16.48z",
    style: {
      transformOrigin: "120.755px 297.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M126.89,293.16c0-2.7,1.24-4.68,4-4.68s4.09,2,4.09,4.68v9.46c0,2.69-1.24,4.67-4.09,4.67s-4-2-4-4.67Zm1.21,9.54c0,2,.79,3.48,2.83,3.48s2.88-1.48,2.88-3.48v-9.62c0-2-.82-3.49-2.88-3.49s-2.83,1.48-2.83,3.49Z",
    style: {
      transformOrigin: "130.935px 297.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m140.15 307.13v-17.38h-3.75v-1.11h8.74v1.11h-3.77v17.38z",
    style: {
      transformOrigin: "140.77px 297.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M156.75,297.65v1.11H152v8.37h-1.21V288.64h7v1.11H152v7.9Z",
    style: {
      transformOrigin: "154.29px 297.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M159.55,293.16c0-2.7,1.24-4.68,4-4.68s4.1,2,4.1,4.68v9.46c0,2.69-1.25,4.67-4.1,4.67s-4-2-4-4.67Zm1.21,9.54c0,2,.8,3.48,2.83,3.48s2.88-1.48,2.88-3.48v-9.62c0-2-.82-3.49-2.88-3.49s-2.83,1.48-2.83,3.49Z",
    style: {
      transformOrigin: "163.6px 297.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M170.86,302.67c0,2,.74,3.51,2.77,3.51s2.78-1.53,2.78-3.51v-14h1.13v14c0,2.64-1.11,4.67-3.93,4.67s-4-2-4-4.67v-14h1.22Z",
    style: {
      transformOrigin: "173.575px 298.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m180.74 307.13h-1.11v-18.49h1.59l5.55 15.61v-15.61h1.11v18.49h-1.35l-5.79-16.48z",
    style: {
      transformOrigin: "183.755px 297.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M194,288.64c2.86,0,4.1,1.88,4.1,4.6v9.3c0,2.72-1.24,4.59-4.1,4.59H190V288.64ZM194,306c2.06,0,2.9-1.41,2.9-3.44v-9.41c0-2-.87-3.43-2.9-3.43h-2.83V306Z",
    style: {
      transformOrigin: "194.05px 297.885px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "396.296px 174.32px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m415.66 82.14s0-4.94-6.91-11.84-11.35-10.86-11.35-10.86-3.45 11.35 3 18.26a122.32 122.32 0 0 0 15.26 13.3z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "406.069px 75.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m405.63 113s0-4.94-6.9-11.84-11.35-10.86-11.35-10.86-3.45 11.35 3 18.26a121.81 121.81 0 0 0 15.29 13.32z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "396.064px 106.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M415.22,90.54s.53-4.91,8.12-11.05,12.43-9.59,12.43-9.59S438,81.55,430.9,87.74a121.71,121.71,0,0,1-16.61,11.63Z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "425.196px 84.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m403.11 126.93s1-4.83 9.24-10.14 13.37-8.23 13.37-8.23 1 11.82-6.72 17.23a121.33 121.33 0 0 1-17.75 9.82z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "413.506px 122.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m405.39 166.6s0-4.94 6.91-11.84 11.34-10.86 11.34-10.86 3.46 11.35-3 18.26a121.81 121.81 0 0 1-15.29 13.32z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "414.958px 159.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M405.28,176.28s.7-4.88-5.16-12.7-9.69-12.36-9.69-12.36-5,10.74.34,18.49A121.74,121.74,0,0,0,404,185.07Z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "396.806px 168.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m398.47 205s0-4.93 6.9-11.84 11.35-10.86 11.35-10.86 3.45 11.35-3 18.26a120.87 120.87 0 0 1-15.29 13.32z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "408.036px 198.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m403.08 231s-1.25-4.78 3.68-13.21 8.24-13.37 8.24-13.37 6.21 10.1 1.76 18.41a122.35 122.35 0 0 1-11.42 16.76z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "410.652px 222.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m416.28 80.87a139.43 139.43 0 0 1-1.89 15.32c-2.73 14.11-9.55 23.21-12.28 35.95s5.1 29.15 3 45.52-8.46 25.46-6.64 36.39 11.37 40.49 11.37 40.49",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "407.213px 167.705px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 415.16,
    x2: 422.6,
    y1: 93.82,
    y2: 88.11,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "418.88px 90.965px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 415.5,
    x2: 412.39,
    y1: 87.24,
    y2: 81.7,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "413.945px 84.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m402.52 131.55s6.23-4.67 12.64-9.34",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "408.84px 126.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m405.63 121.83s-5.19-10.18-11.07-16.93",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "400.095px 113.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M405.64,173.62A77,77,0,0,1,419,155.79",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "412.32px 164.705px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m404.42 180.54a86.78 86.78 0 0 0-6.75-12.81c-3.63-5.37-4.15-6.06-4.15-6.06",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "398.97px 171.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m398.47 214.05a82.12 82.12 0 0 1 5.61-11.35 72.05 72.05 0 0 1 7.27-9.52",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "404.91px 203.615px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m405.33 239.59a21.19 21.19 0 0 1 1.86-10.93c2.6-5 5.54-11.6 6.75-14.19",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "409.586px 227.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M370.43,148s-.54-3.09,3.05-8.17,5.93-8,5.93-8,3.4,6.74.13,11.77a76.51,76.51,0,0,1-8.15,10Z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "375.681px 142.715px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M380.06,166.28s-.54-3.1,3.05-8.18,5.93-8,5.93-8,3.4,6.74.13,11.77a76.51,76.51,0,0,1-8.15,10Z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "385.311px 160.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M371.61,153.27s-.86-3-6.29-6.05-8.83-4.67-8.83-4.67-.14,7.55,5,10.66a77.4,77.4,0,0,0,11.68,5.49Z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "364.83px 150.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M383.16,174.77s-1.17-2.91-6.89-5.35-9.28-3.71-9.28-3.71.66,7.52,6.08,10.07a77.72,77.72,0,0,0,12.2,4.23Z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "376.13px 172.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M386,199.89s-.54-3.09-5.62-6.67-8.29-5.58-8.29-5.58-.94,7.49,3.83,11.13a78.05,78.05,0,0,0,11,6.69Z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "379.467px 196.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m387.16 206s-1-3 1.85-8.52 4.74-8.8 4.74-8.8 4.32 6.19 1.79 11.63a77.27 77.27 0 0 1-6.63 11.07z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "391.662px 200.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M395.83,230.91s.36-3.12,5.23-7,8-6,8-6,1.36,7.43-3.2,11.33a77,77,0,0,1-10.63,7.31Z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "402.24px 227.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.55,223.21s-.54-3.09-5.62-6.68-8.29-5.57-8.29-5.57-.94,7.49,3.83,11.13a78.05,78.05,0,0,0,11,6.69Z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "388.017px 219.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.48,240s.26-3.13-3.74-7.88-6.61-7.5-6.61-7.5-2.81,7,.89,11.74a78.12,78.12,0,0,0,9,9.27Z",
    fill: "#92e3a9",
    style: {
      transformOrigin: "388.796px 235.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m369.9 147.32a89.48 89.48 0 0 0 2.85 9.4c3.24 8.55 8.51 13.51 11.61 21.21s0 18.84 3.05 28.87 8.08 15 8.12 22.09-2.74 26.64-2.74 26.64",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "382.715px 201.425px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 372.01,
    x2: 366.73,
    y1: 155.31,
    y2: 152.54,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "369.37px 153.925px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 371.08,
    x2: 372.43,
    y1: 151.23,
    y2: 147.42,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "371.755px 149.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m384 177.61s-4.41-2.26-8.94-4.49",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "379.53px 175.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m381 171.84a63.07 63.07 0 0 1 5.13-11.84",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "383.565px 165.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m386.65 204.32a49.28 49.28 0 0 0-10.3-9.73",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "381.5px 199.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m388.16 208.53a55 55 0 0 1 2.84-8.76c1.7-3.76 1.95-4.25 1.95-4.25",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "390.555px 202.025px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m395.29 234.24a46 46 0 0 1 5.69-5.9 30.62 30.62 0 0 0 3.69-3.21",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "399.98px 229.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m395.53 228.89a52.72 52.72 0 0 0-4.75-6.5 46.33 46.33 0 0 0-5.59-5.18",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "390.36px 223.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m394 245.66a13.38 13.38 0 0 0-2.36-6.65c-2.17-2.87-4.73-6.67-5.77-8.17",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "389.935px 238.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m416.48 289.2h-30.41a2.88 2.88 0 0 1-2.87-2.87l-4.52-34.22h45.18l-4.51 34.22a2.88 2.88 0 0 1-2.87 2.87z",
    fill: "#263238",
    style: {
      transformOrigin: "401.27px 270.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m423.47 258h-44.79a3.53 3.53 0 0 1-3.53-3.53 3.53 3.53 0 0 1 3.53-3.54h44.79a3.54 3.54 0 0 1 3.54 3.54 3.54 3.54 0 0 1-3.54 3.53z",
    fill: "#263238",
    style: {
      transformOrigin: "401.08px 254.465px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "286.056px 262.485px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m380.32 329.29a4.71 4.71 0 0 1-4.24-6.78 8 8 0 0 0-3.17-10.51c-7.06-4.52-23.48-5.24-29.23-5.15h-0.08a4.72 4.72 0 0 1-0.09-9.44c2.41-0.05 23.76-0.22 34.48 6.64 10.57 6.77 8.93 17.71 6.58 22.56a4.73 4.73 0 0 1-4.25 2.68z",
    fill: "#263238",
    style: {
      transformOrigin: "362.576px 313.344px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "402.08 354.19 401.04 357.72 385.29 331.82 384.88 326.23",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "393.48px 341.975px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "401.04 357.72 405.96 355.29 406.84 351.92 402.08 354.19",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "403.94px 354.82px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "382.81 323.33 401.04 322.7 406.84 351.92 402.08 354.19",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "394.825px 338.445px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "380.32 324.57 398.55 355.23 392.55 358.13 365.61 336.17",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "382.08px 341.35px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "392.55 358.13 391.72 361.24 364.58 339.69 365.61 336.17",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "378.565px 348.705px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "392.55 358.13 398.55 355.23 397.73 358.34 391.72 361.24",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "395.135px 358.235px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 383.9,
    cy: 329.09,
    r: 9.24,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "383.9px 329.09px",
      transform: "rotate(-45deg)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "189.17 354.19 190.21 357.72 205.95 331.82 206.37 326.23",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "197.77px 341.975px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "190.21 357.72 185.29 355.29 184.41 351.92 189.17 354.19",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "187.31px 354.82px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "208.44 323.33 190.21 322.7 184.41 351.92 189.17 354.19",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "196.425px 338.445px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "210.93 324.57 192.69 355.23 198.7 358.13 225.63 336.17",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "209.16px 341.35px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "198.7 358.13 199.53 361.24 226.67 339.69 225.63 336.17",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "212.685px 348.705px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "198.7 358.13 192.69 355.23 193.52 358.34 199.53 361.24",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "196.11px 358.235px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m207.94 332.43a4.72 4.72 0 0 1-3-8.38c37.52-30.53 29.88-76.06 29.8-76.52a4.72 4.72 0 0 1 9.29-1.66c0.37 2.09 8.66 51.5-33.13 85.5a4.7 4.7 0 0 1-2.96 1.06z",
    fill: "#263238",
    style: {
      transformOrigin: "224.068px 287.262px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 244.5,
    cy: 234.51,
    r: 18.48,
    fill: "#adadad",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "244.5px 234.51px",
      transform: "rotate(-80.83deg)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 207.34,
    cy: 329.09,
    r: 9.24,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "207.34px 329.09px",
      transform: "rotate(-45deg)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 293.99,
    cy: 283.27,
    rx: 29.33,
    ry: 27.36,
    fill: "#adadad",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "293.99px 283.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M278.71,271.58l2.74,10.69a11.76,11.76,0,0,0,12.69,8.23h0a11.74,11.74,0,0,0,10.27-11.08l.54-10.78Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "291.83px 279.615px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m336.53 217.79a27.51 27.51 0 0 1-8.18-1.12l0.76-2.23c0.13 0 13.26 4.27 26.63-5.51l1.39 1.91a34.54 34.54 0 0 1-20.6 6.95z",
    fill: "#263238",
    style: {
      transformOrigin: "342.74px 213.361px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M351.27,235.53c-10.82-15.81-23.13-14.62-23.25-14.61l-.26-2.34c.56-.06,13.85-1.35,25.45,15.62Z",
    fill: "#263238",
    style: {
      transformOrigin: "340.485px 227.033px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M348.53,246.7c-14-4.31-22.41-22.95-22.77-23.74l2.16-1c.08.19,8.34,18.45,21.31,22.44Z",
    fill: "#263238",
    style: {
      transformOrigin: "337.495px 234.33px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 355.81,
    x2: 359.59,
    y1: 210.52,
    y2: 208,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "357.7px 209.26px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 351.19,
    x2: 353.71,
    y1: 232.77,
    y2: 237.8,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "352.45px 235.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M346.78,244.73a27.5,27.5,0,0,0,6.09.84",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "349.825px 245.15px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "240.63 214.32 244.12 238.73 330.97 229.85 330.65 204.49",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "285.8px 221.61px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "244.12 238.73 259.65 278.03 326.53 271.37 330.97 229.85",
    fill: "#e5e5e5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "287.545px 253.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m265.07 249 6.1 18a5.93 5.93 0 0 0 6.36 4l26.79-2.92a5.94 5.94 0 0 0 5.2-5.38l1.66-18.93a4.19 4.19 0 0 0-4.65-4.54l-37.93 4.24a4.21 4.21 0 0 0-3.53 5.53z",
    fill: "#263238",
    style: {
      transformOrigin: "288.023px 255.124px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    clipPath: "url(#a)",
    style: {
      transformOrigin: "289.655px 255.805px"
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "animable",
    points: "265.07 258.89 276.13 257.91 279.64 248.38 287.9 263.23 292.1 252.16 294.2 255.67 314.24 253.28",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "289.655px 255.805px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m265.07 249 6.1 18a5.93 5.93 0 0 0 6.36 4l26.79-2.92a5.94 5.94 0 0 0 5.2-5.38l1.66-18.93a4.19 4.19 0 0 0-4.65-4.54l-37.93 4.24a4.21 4.21 0 0 0-3.53 5.53z",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "288.023px 255.124px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 320.89,
    cy: 241.32,
    r: 4.86,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "320.89px 241.32px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m324.85 256.52a4.56 4.56 0 1 1-4.56-4.56 4.56 4.56 0 0 1 4.56 4.56z",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "320.29px 256.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m261.72 246.6a4.86 4.86 0 1 1-6.06-3.25 4.85 4.85 0 0 1 6.06 3.25z",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "257.067px 248.001px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 260.87,
    cy: 262.73,
    r: 4.56,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "260.87px 262.73px",
      transform: "rotate(-57deg)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 276.37,
    cy: 302.72,
    rx: 12.92,
    ry: 12.46,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "276.37px 302.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m257.37 330.68 11.83-26.56a5.09 5.09 0 0 1 6.17-2.79h0a5.09 5.09 0 0 1 3.47 6l-7.79 34.92z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "268.169px 321.674px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m253.42 290 25.83 60.79-31 4.26s-18.54-18.85-31-54.71z",
    fill: "#adadad",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "248.25px 322.525px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "253.42 289.95 254.63 284.18 280.47 346.18 279.25 350.74",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "266.945px 317.46px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "254.63 284.18 219.38 294.81 217.25 300.29 253.42 289.95",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "235.94px 292.235px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 219.68,
    x2: 255.24,
    y1: 306.06,
    y2: 295.12,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "237.46px 300.59px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 222.41,
    x2: 258.28,
    y1: 312.44,
    y2: 302.72,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "240.345px 307.58px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 225.15,
    x2: 261.32,
    y1: 319.13,
    y2: 309.41,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "243.235px 314.27px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 229.1,
    x2: 264.36,
    y1: 327.34,
    y2: 317,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "246.73px 322.17px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 232.84,
    x2: 268.01,
    y1: 333.86,
    y2: 324.6,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "250.425px 329.23px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 236.7,
    x2: 271.05,
    y1: 339.82,
    y2: 331.59,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "253.875px 335.705px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 241.15,
    x2: 273.17,
    y1: 345.55,
    y2: 337.98,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "257.16px 341.765px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 244.3,
    x2: 276.11,
    y1: 350.23,
    y2: 344.97,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "260.205px 347.6px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 310.78,
    cy: 302.72,
    rx: 12.92,
    ry: 12.46,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "310.78px 302.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m329.77 330.68-11.83-26.56a5.09 5.09 0 0 0-6.17-2.79h0a5.08 5.08 0 0 0-3.46 6l7.79 34.92z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "318.975px 321.674px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m333.73 290-25.84 60.79 31 4.26s18.54-18.85 31-54.71z",
    fill: "#adadad",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "338.89px 322.525px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "333.73 289.95 332.51 284.18 306.67 346.18 307.89 350.74",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "320.2px 317.46px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "332.51 284.18 367.77 294.81 369.9 300.29 333.73 289.95",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "351.205px 292.235px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 367.46,
    x2: 331.9,
    y1: 306.06,
    y2: 295.12,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "349.68px 300.59px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 364.73,
    x2: 328.86,
    y1: 312.44,
    y2: 302.72,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "346.795px 307.58px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 361.99,
    x2: 325.82,
    y1: 319.13,
    y2: 309.41,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "343.905px 314.27px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 358.04,
    x2: 322.78,
    y1: 327.34,
    y2: 317,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "340.41px 322.17px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 354.3,
    x2: 319.14,
    y1: 333.86,
    y2: 324.6,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "336.72px 329.23px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 350.44,
    x2: 316.1,
    y1: 339.82,
    y2: 331.59,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "333.27px 335.705px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 346,
    x2: 313.97,
    y1: 345.55,
    y2: 337.98,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "329.985px 341.765px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 342.84,
    x2: 311.03,
    y1: 350.23,
    y2: 344.97,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "326.935px 347.6px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 357.28,
    x2: 360.64,
    y1: 238.01,
    y2: 239.48,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "358.96px 238.745px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 355.18,
    x2: 358.54,
    y1: 239.27,
    y2: 244.52,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "356.86px 241.895px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 353.29,
    x2: 352.66,
    y1: 239.48,
    y2: 242.84,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "352.975px 241.16px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 361.48,
    x2: 369.66,
    y1: 217.65,
    y2: 217.65,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "365.57px 217.65px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 355.18,
    x2: 366.93,
    y1: 218.07,
    y2: 221.43,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "361.055px 219.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 359.59,
    x2: 367.14,
    y1: 213.67,
    y2: 212.62,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "363.365px 213.145px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 332.51,
    x2: 334.61,
    y1: 239.69,
    y2: 245.78,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "333.56px 242.735px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 335.24,
    x2: 341.11,
    y1: 239.27,
    y2: 248.93,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "338.175px 244.1px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 337.34,
    x2: 343,
    y1: 233.61,
    y2: 235.5,
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "340.17px 234.555px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "368.61 230.46 366.72 232.52 368.09 234.96 365.54 233.79 363.65 235.85 363.97 233.07 361.43 231.9 364.17 231.35 364.5 228.57 365.87 231.01",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".54081px",
    style: {
      transformOrigin: "365.02px 232.21px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "371.55 202.75 369.65 204.81 371.03 207.25 368.48 206.08 366.59 208.14 366.91 205.36 364.37 204.19 367.11 203.64 367.43 200.86 368.81 203.3",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".54081px",
    style: {
      transformOrigin: "367.96px 204.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "340.9 251.24 339.01 253.3 340.38 255.74 337.84 254.57 335.94 256.63 336.26 253.85 333.72 252.68 336.46 252.13 336.79 249.35 338.16 251.79",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".54081px",
    style: {
      transformOrigin: "337.31px 252.99px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 250.3,
    cy: 191.5,
    rx: 14.11,
    ry: 13.95,
    fill: "#adadad",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "250.3px 191.5px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 311.79,
    cy: 187.69,
    rx: 14.11,
    ry: 13.95,
    fill: "#adadad",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "311.79px 187.69px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 283.42,
    cy: 217.01,
    rx: 17.75,
    ry: 16.96,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "283.42px 217.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M270.43,208.3l2.45,10.76a11.73,11.73,0,0,0,12.45,8.57h0a11.75,11.75,0,0,0,10.58-10.79l.83-10.76Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "283.585px 216.883px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "254.26 162.97 247.61 189.6 313.85 184.21 304.03 158.85",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "280.73px 174.225px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "247.61 189.6 259.33 218.76 311.32 213.69 313.85 184.21",
    fill: "#e5e5e5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "280.73px 201.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m277.4 201.49c-0.18 4.14-3.8 7.4-8.13 7.73s-8.57-2.38-9.5-6.48c-1-4.7 2.51-9.32 8.06-9.67s9.76 3.7 9.57 8.42z",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "268.503px 201.148px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m274.09 201.72a5.22 5.22 0 0 1-5 5 5.45 5.45 0 0 1-5.9-4.21c-0.49-2.84 1.74-5.51 5-5.73a5.32 5.32 0 0 1 5.9 4.94z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "268.606px 201.749px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m306.87 198.64c-0.17 4.14-3.79 7.4-8.12 7.73s-8.58-2.38-9.5-6.49c-1.05-4.69 2.51-9.31 8.06-9.67s9.76 3.71 9.56 8.43z",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "297.972px 198.292px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m303.56 198.87a5.21 5.21 0 0 1-5 5 5.46 5.46 0 0 1-5.9-4.22c-0.49-2.84 1.74-5.5 5-5.72a5.3 5.3 0 0 1 5.9 4.94z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "298.076px 198.898px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M277.72,213.51a2.36,2.36,0,0,1-.24-4.71l12.68-1.27a2.36,2.36,0,0,1,.47,4.7L278,213.5Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "284.045px 210.514px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 255.48,
    cy: 171.28,
    r: 4.79,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "255.48px 171.28px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 252.52,
    cy: 168.49,
    r: 4.09,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "252.52px 168.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m251.73 164.14a3.22 3.22 0 1 1-3.22-3.23 3.22 3.22 0 0 1 3.22 3.23z",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "248.51px 164.13px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 247.73,
    x2: 240.41,
    y1: 163.01,
    y2: 156.21,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "244.07px 159.61px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 302.52,
    cy: 167.97,
    r: 4.79,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "302.52px 167.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 305.48,
    cy: 165.18,
    r: 4.09,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "305.48px 165.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m306.27 160.83a3.22 3.22 0 1 0 3.22-3.23 3.22 3.22 0 0 0-3.22 3.23z",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "309.49px 160.82px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 310.27,
    x2: 317.59,
    y1: 159.69,
    y2: 152.9,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "313.93px 156.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m299.55 335.58c0 2.31-1.53 4.18-3.42 4.18s-3.41-1.87-3.41-4.18 1.53-4.18 3.41-4.18 3.42 1.87 3.42 4.18z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "296.135px 335.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M306.31,339.08l-.26,0-9.49-1.39a1.77,1.77,0,0,1,.51-3.5l9.49,1.38a1.77,1.77,0,0,1-.25,3.53Z",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "301.639px 336.641px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m173.68 355.12c-1.24-1.95-1-4.35 0.64-5.35s3.88-0.25 5.12 1.69 0.95 4.35-0.65 5.36-3.88 0.25-5.11-1.7z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "176.552px 353.297px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M166.09,355.79a1.67,1.67,0,0,1,.23-.12l8.76-3.91a1.77,1.77,0,0,1,1.44,3.23l-8.76,3.91a1.77,1.77,0,0,1-1.67-3.11Z",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "171.385px 355.345px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m400.31 310.32c-1.24-1.95-0.95-4.34 0.64-5.35s3.88-0.25 5.12 1.69 0.95 4.35-0.64 5.36-3.89 0.25-5.12-1.7z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "403.19px 308.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M392.73,311l.22-.12,8.76-3.91a1.77,1.77,0,1,1,1.44,3.23l-8.75,3.91a1.77,1.77,0,0,1-1.67-3.11Z",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "398.092px 310.522px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m231.18 357c-4 0-7.22 1.92-7.22 4.28s3.23 4.28 7.22 4.28 7.23-1.92 7.23-4.28-3.24-4.28-7.23-4.28zm0 6.49c-2.06 0-3.73-1-3.73-2.21s1.67-2.21 3.73-2.21 3.74 1 3.74 2.21-1.67 2.21-3.74 2.21z",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "231.185px 361.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M296.26,357.69l-4.93-2-4.94,2-1.22,4.4,3.42,3.53h5.48l3.41-3.53Zm-3.54,5.62h-2.78l-1.74-1.79.62-2.23,2.51-1,2.5,1,.62,2.23Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "291.325px 360.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.82,293.8l-4.94-2-4.94,2-1.22,4.41,3.42,3.53h5.48l3.42-3.53Zm-3.55,5.63h-2.78l-1.73-1.79.61-2.24,2.51-1,2.51,1,.62,2.24Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "384.88px 296.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M329.27,367.73a1.22,1.22,0,0,1-.41-.07,3.5,3.5,0,0,1-1.62-1.39c-.55-.85-1-2.36-.13-4.7a5.54,5.54,0,0,1,3.85-3.51,7.52,7.52,0,0,1,6.53,1.49,1.17,1.17,0,0,1,.16,1.66,1.18,1.18,0,0,1-1.66.16,5.2,5.2,0,0,0-4.42-1,3.24,3.24,0,0,0-2.25,2.07c-.89,2.35.18,3,.4,3.06a1.2,1.2,0,0,1,.63,1.53A1.16,1.16,0,0,1,329.27,367.73Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "332.272px 362.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M353.65,372.07a3.55,3.55,0,0,1-1.1-.17l-19.19-6.25a3.54,3.54,0,1,1,2.19-6.73l19.2,6.25a3.54,3.54,0,0,1-1.1,6.9Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "343.999px 365.393px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M332.78,365.49s.76-4.88,6.86-5",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "336.21px 362.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M336.89,366.55s.77-4.87,6.86-5",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "340.32px 364.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M340.55,367.92s.76-4.87,6.85-5",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "343.975px 365.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M344.36,369s.76-4.87,6.85-5",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "347.785px 366.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M348.17,370.36s.76-4.87,6.85-5",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "351.595px 367.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M353.64,372a1.14,1.14,0,0,1-.4-.08,3.46,3.46,0,0,1-1.63-1.38c-.55-.85-1-2.36-.13-4.71a5.58,5.58,0,0,1,3.85-3.51,7.52,7.52,0,0,1,6.53,1.5,1.17,1.17,0,0,1,.16,1.66,1.18,1.18,0,0,1-1.66.16,5.19,5.19,0,0,0-4.42-1,3.21,3.21,0,0,0-2.25,2.06c-.89,2.36.18,3,.4,3.06a1.19,1.19,0,0,1-.45,2.28Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px",
    style: {
      transformOrigin: "356.642px 367.076px"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m265.07 249 6.1 18a5.93 5.93 0 0 0 6.36 4l26.79-2.92a5.94 5.94 0 0 0 5.2-5.38l1.66-18.93a4.19 4.19 0 0 0-4.65-4.54l-37.93 4.24a4.21 4.21 0 0 0-3.53 5.53z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.0816px"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.1b06ae6cb95615efb4219e318a8ba9e0.svg";
export { ForwardRef as ReactComponent };